<template>
  <div class="c-detail-concat-list-con">
    <TableComponent :data="data" :condition="condition" :currentChange="currentChange" :isLoading="isLoading" class="form-table">
      <el-table-column label="操作时间">
        <template slot-scope="scope">
          <span v-analysis-time="scope.row.created_at"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作内容">
        <template slot-scope="scope">
          {{options.customer_levels[scope.row.level] || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="操作人">
        <template slot-scope="scope">
          {{scope.row.admin_name || '--'}}
        </template>
      </el-table-column>
    </TableComponent>
  </div>
</template>
<script>
import {getClewLevelList} from  '@/api/custome';
import TableComponent from '@/components/table/index';
import { configKeys } from '@/setting/index';
export default {
  name: 'ClewLevel',
  props: {
    currentsClew: Object
  },
  components: {
    TableComponent
  },
  data () {
    return {
      data: [],
      condition: {
        page: 1,
        per_page: 10,
        total: 0
      },
      isLoading: false
    }
  },
  async mounted () {
    this.initOperateList();
    this.options = await this.$store.dispatch('initConfig', [configKeys.customer_levels]);
  },
  methods: {
    // 初始化操作列表
    async initOperateList () {
      if (!this.currentsClew.admin_id || !this.currentsClew.clew_id) return null;
      this.isLoading = true;
      try {
        const res = await getClewLevelList(this.currentsClew.admin_id, this.currentsClew.clew_id, this.condition);
        this.data = res.data || [];
        this.$set(this.condition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      } finally {
        this.isLoading = false;
      }
    },
    // 切换当前页
    currentChange (current) {
      this.$set(this.condition, 'page', current);
      this.initOperateList();
    }
  }
}
</script>